export const environment = {
  production: true,
  url: 'https://api.sandbox-taqe.com/v2',
  api_gateway: 'https://api-gateway.sandbox-taqe.com',
  landinpage: 'https://vagas.sandbox-taqe.com',
  web_link: 'https://gerenciador.sandbox-taqe.com',
  manager_type: 'taqe',
  hotjar_id: '1665051',
  url_redirect: {
    web_web_v2: 'https://gerenciador.sandbox-taqe.com',
    web_web_v2_lite: 'https://vitrine.sandbox-taqe.com',
  },
  talent_base: false,
  microfrontend: {
    test_module: 'https://mfe-modulo-test.sandbox-taqe.com/main.js'
  },
  pwa_url: 'https://app.sandbox-taqe.com',
  ip_url: 'https://app-ip.sandbox-taqe.com',
  mock_vacancy_step_id: '5a1109341f8773001',
  MAPS_API_KEY: 'AIzaSyBGU9uctwX3wHeiWlN3_fvht30dJ1qsq58',
  secureCookie: true,
  timeToLogoutInSeconds: 3600,
  chatWoot_Url:'https://chatwoot.sandbox-taqe.com',
  chatWoot_Token: 'afEsphLdqb9zVf2RTBNRRLKb',
  redeCidada_ids: ['67f957033cb78c1ac1c35767','5f6e59d1a2c11f001d801ca2','6822739ad68347c30594966b','6835ff01d7da1c97085afeb5','6759e6dc4df6f6aac530350f','686fcd9e0c6dbf9bc4ca2932','6835ff01d7da1c97085afeb5','6970c9371b14b6055183421e']
};
